import { Box, Typography } from "@mui/material";
import PurchaseGreenSvg from "@/assets/svg/PurchaseGreenSvg";
import PurchaseRedSvg from "@/assets/svg/PurchaseRedSvg";
import { stylesPurchaseRow as styles } from "./stylesPurchaseRow";
import { useNavigate } from "react-router-dom";
import PurchaseArrow from "@/assets/svg/PurchaseArrow";
import { formatToEnglishDateTime } from "@/helpers/getHoursDifference";
import { formatMoney } from "@/helpers/formatMoney";

interface PurchaseRowProps {
  title: string;
  date: string;
  amount: number;
  // sats: string;
  positive?: boolean;
  status?: "PENDING" | "COMPLETED" | "FAILED";
  relatedEntityId?: string;
  fee?: number;
}

export const PurchaseRow = ({
  title,
  date,
  amount,
  // sats,
  positive = true,
  status,
  relatedEntityId,
  fee,
}: PurchaseRowProps) => {
  const Icon = positive ? PurchaseGreenSvg : PurchaseRedSvg;
  const satsColor = positive ? "#75B976" : "#FF403D";
  const navigate = useNavigate();

  const handleClick = () => {
    if (relatedEntityId) {
      navigate(`/post/${relatedEntityId}`);
    }
  };

  return (
    <Box sx={styles.row}>
      <Box sx={styles.leftSection}>
        <Box sx={styles.iconWrapper}>
          <Icon />
        </Box>
        <Box>
          <Typography sx={styles.title} onClick={handleClick}>
            {title}
          </Typography>
          <Typography sx={styles.date}>{formatToEnglishDateTime(date)}</Typography>
        </Box>
      </Box>

      <Box sx={styles.centerSection}>
        <Typography sx={{ ...styles.sats, color: satsColor }}>
          {positive ? "+$" : "-$"}
          {formatMoney(amount)}
        </Typography>
        {/* <Typography sx={{ ...styles.sats, color: satsColor }}>
          {positive ? "+" : "-"}
          {sats}
        </Typography> */}
      </Box>

      <Box sx={styles.feeSection}>
        {fee && fee > 0 ? (
          <Typography sx={styles.feeText}>
            ${formatMoney(fee)} <Box component="span" sx={styles.feeLabel}>(Fee)</Box>
          </Typography>
        ) : null}
      </Box>

      <Box sx={styles.arrowSection}>
        {status ? (
          <Box sx={styles.wrapper}>
            <Box
              sx={{
                ...styles.statusBase,
                ...(status === "PENDING"
                  ? styles.statusPending
                  : status === "COMPLETED"
                    ? styles.statusCompleted
                    : styles.statusFailed),
              }}
            >
              {status === "PENDING" ? "Pending..." : status === "COMPLETED" && "Completed"}
            </Box>
          </Box>
        ) : (
          <Box sx={{ display: "contents" }} onClick={handleClick}>
            <PurchaseArrow />
          </Box>
        )}
      </Box>
    </Box>
  );
};
